<!-- 店铺认领 -->
<template>
  <van-action-sheet
    :closeable="false"
    class="store-sheet-action"
    title="店铺门面示例"
  >
    <div class="content">
      <slot></slot>
      <div class="split"></div>
      <div class="fn-wrap">
        <div class="fn-wrap-item" @click="getImage">
          <img class="icon" :src="require('@/assets/images/my/camera.png')" />
          拍照
        </div>
        <div class="fn-wrap-item" @click="galleryImg">从手机相册选择</div>
      </div>
      <div class="split"></div>
      <div class="fn-wrap">
        <div class="fn-wrap-item cache-btn" @click="emits('close')">取消</div>
      </div>
    </div>
    <!-- <img id="storeActionImg" :src="imgPath111" crossorigin="anonymous" /> -->
  </van-action-sheet>
</template>
<script setup>
import { defineEmits, ref } from "vue";
import { galleryUpload, gameraUpload } from "@/js_sdk/common";
const imgPath111 = ref("");
/** 获取抽屉DOM */
const emits = defineEmits(["close", "uploadImage"]); // 抽屉配置

//拍照
function getImage() {
  gameraUpload({
    title: "访问相机权限说明",
    tip: "拍摄店铺现场照片",
    succeed: (url) => {
      console.log("succeed url", url);
      emits("uploadImage", url);
    },
  });
}

//本地相册选择
function galleryImg() {
  galleryUpload({
    title: "访问照片文件权限说明",
    tip: "上传店铺现场照片",
    succeed: (url) => {
      emits("uploadImage", url);
    },
  });
}
</script>

<style lang="scss">
.store-sheet-action {
  max-height: 8.6rem;
  // padding-bottom: calc(constant(safe-area-inset-bottom));
  // padding-bottom: calc(env(safe-area-inset-bottom));
  .content {
    .split {
      height: 0.16rem;
      background: #f7f8fa;
    }
    .example-img {
      display: flex;
      justify-content: center;
      padding-bottom: 0.16rem;
      img {
        height: 3.78rem;
      }
    }

    .fn-wrap {
      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.32rem;
        font-weight: 400;
        color: #02040f;
        padding: 0.28rem 0;
        .icon {
          width: 0.32rem;
          height: 0.32rem;
          margin-right: 0.08rem;
        }
      }
    }
    .cache-btn {
      font-size: 0.32rem;
      font-weight: 400;
      color: rgba(2, 4, 15, 0.45);
    }
  }
}
</style>
